import _ from 'lodash';


const surveyQuestionEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'SurveyQuestionTypeEnum' }
};


export default class SurveyQuestion {
  constructor(type = null) {
    this.fields.type.value = type;
  }

  fields = {
    id: {
      value: null
    },
    billing_profile_id: {
      value: null
    },
    type: {
      value: null
    },
    structure: {
      value: new SurveyQuestionStructure()
    },
    order: {
      value: null
    },
    created_at: {
      value: null
    },
    updated_at: {
      value: null
    }
  };


  static createFromQueryValues(values) {
    const surveyQuestion = new this();

    for (let field in surveyQuestion.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'structure':
            surveyQuestion.fields[field].value = (values[field] === null) ?
              values[field] :
              SurveyQuestionStructure.createFromQueryValues(values[field]);
            break;
          case 'created_at':
          case 'updated_at':
            surveyQuestion.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          default:
            surveyQuestion.fields[field].value = values[field];
        }
      }
    }

    return surveyQuestion;
  }


  getQueryFieldValues() {
    if (this.fields.structure.value === null) {
      return false;
    }

    const values = _.cloneDeep(SurveyQuestionInput);

    for (let field in values) {
      switch (field) {
        case 'id':
          if (this.fields[field].value === null) {
            delete values[field];
          }
          else {
            values[field] = this.fields[field].value;
          }
          break;
        case 'structure':
          const structure = this.fields.structure.value.getQueryFieldValues();
          if (structure) {
            values[field] = structure;
          }
          break;
        default:
          values[field] = this.fields[field].value;
      }
    }

    return values;
  }
}


export const SurveyQuestionInput = {
  id: null,
  type: null,
  structure: null
}


export class SurveyQuestionStructure {
  fields = {
    prompt: {
      value: null
    },
    type: {
      value: null
    },
    options: {
      value: []
    }
  };


  static createFromQueryValues(values) {
    const surveyQuestionStructure = new this();

    for (let field in surveyQuestionStructure.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'options':
            for (let option of values.options) {
              surveyQuestionStructure.fields.options.value.push(SurveyQuestionStructureOption.createFromQueryValues(option));
            }
            break;
          default:
            surveyQuestionStructure.fields[field].value = values[field];
        }
      }
    }

    return surveyQuestionStructure;
  }


  getQueryFieldValues() {
    const values = {};

    if (this.fields.prompt.value !== null) {
      values.prompt = this.fields.prompt.value;
    }
    if (this.fields.type.value !== null) {
      values.type = this.fields.type.value;
    }
    if (this.fields.options.value.length &&
      this.fields.type.value !== null &&
      SurveyQuestionStructureType[this.fields.type.value].hasDefinedResponses
    ) {
      values.options = [];
      for (let option of this.fields.options.value) {
        const optionQueryFieldValues = option.getQueryFieldValues();
        if (optionQueryFieldValues) {
          values.options.push(optionQueryFieldValues);
        }
      }
    }

    return values;
  }
}


export const SurveyQuestionStructureType = {
  SELECT: {
    value: 'SELECT',
    label: 'Selection (Drop Down)',
    hasDefinedResponses: true
  },
  RADIO: {
    value: 'RADIO',
    label: 'Selection (Radio Button)',
    hasDefinedResponses: true
  },
  TEXT: {
    value: 'TEXT',
    label: 'Text',
    hasDefinedResponses: false
  }
}


export class SurveyQuestionStructureOption {
  fields = {
    response: {
      value: null
    },
    next_question: {
      value: null
    }
  }


  static createFromQueryValues(values) {
    const surveyQuestionStructureOption = new this();

    if (values.hasOwnProperty('response')) {
      surveyQuestionStructureOption.fields.response.value = values.response;
    }
    if (values.hasOwnProperty('next_question') && values.next_question) {
      surveyQuestionStructureOption.fields.next_question.value = SurveyQuestionStructure.createFromQueryValues(values.next_question);
    }
    else {
      delete surveyQuestionStructureOption.next_question;
    }

    return surveyQuestionStructureOption;
  }


  getQueryFieldValues() {
    if (this.fields.response.value === null &&
        this.fields.next_question.value === null
    ) {
      return false;
    }

    const values = {};

    if (this.fields.response.value !== null) {
      values.response = this.fields.response.value;
    }
    if (this.fields.next_question.value !== null) {
      values.next_question = this.fields.next_question.value.getQueryFieldValues();
    }

    return values;
  }
}
